export default __webpack_public_path__ + "static/media/trainer2.dbf612cc.png";